import React, { Component } from 'react'
import { Icon, List, WingBlank, WhiteSpace, Button, InputItem, Toast, NavBar } from 'antd-mobile'
import axios from "../../../../service/axios";
import NoneDatas from "../../../../components/noneDatas";
import { createForm } from 'rc-form';

export class BatchModifyGroup extends Component {
  state = {
    infoList: []
  };

  componentWillMount() {
  }

  //名称校验
  validateName = (rule, value, callback) => {
    if (value) {
      if (value.trim()) {
        if (/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,11}$/.test(value)) {
          callback();
        } else {
          callback(new Error("名称只支持1~11位中文数字字母和下划线"));
        }
      } else {
        callback(new Error("请填写群组名"));
      }
    } else {
      callback(new Error("请填写群组名"));
    }
  };
  onSave() {
    console.log(this.props.form.getFieldsValue());
    const { groupList } = this.props;
    const fieldsValues = this.props.form.getFieldsValue();
    this.props.form.validateFields({ force: true }, error => {
      console.log(error);
      if (!error) {
        const values = groupList.map(item => {
          const name = 'name' + item.gid;
          return {
            gid: item.gid,
            name: fieldsValues[name],
          }
        })
        console.log(values)
        axios.post("/api/group/name/update", values).then(res => {
          if (res && res.status == 200) {
            Toast.success(res.message, 2, () => {
              window.location.reload();
            });
          } else {
            Toast.fail(res.message);
          }
        });
      } else {
        const keys = Object.keys(error);
        if (keys && keys.length > 0) {
          const err = this.props.form.getFieldError(keys[0]);
          Toast.fail(err);
        }
      }
    });
  };

  render() {
    const { getFieldProps } = this.props.form
    const { groupList } = this.props
    return (
      <div className="container">
        <List>
          {groupList.map((item, index) => (
            <div key={index}>
              <InputItem disabled>群组{index + 1}：</InputItem>
              <InputItem placeholder="支持1~11位的中文数字字母或下划线"
                {...getFieldProps('name' + item.gid, {
                  rules: [
                    {
                      validator: this.validateName,
                    },
                  ],
                  initialValue: item.name,
                })}
                maxLength={11}>名称</InputItem>
            </div>
          ))}
          {groupList.length == 0 ? <NoneDatas /> : ""}
          <WingBlank>
            <WhiteSpace size="xl" />
            <Button type="primary" onClick={() => this.onSave()}>
              确定
            </Button>
            <WhiteSpace size="xl" />
            <Button type="" onClick={() => this.props.handleChildClose()}>
              返回
            </Button>
            <WhiteSpace size="xl" />
          </WingBlank>
        </List>
      </div >
    )
  }
}

export default createForm()(BatchModifyGroup);
